import { createReducer } from 'redux-act';
import * as actions from 'modules/actions';
import { Privacy } from 'modules/types';

export interface ILeague {
	readonly id: number;
	readonly user_id: number;
	readonly first_name: string;
	readonly last_name: string;
	readonly name: string;
	readonly status: 'scheduled' | 'completed' | 'playing';
	readonly privacy: Privacy;
	readonly code: string;
	readonly num_teams: number;
	readonly start_at: Date;
	readonly class: string;
	readonly overall_points: number;
	readonly overall_rank: number;
	readonly event_points: number;
	readonly start_event_id: number;
	end_event_id?: number;
	readonly previous_overall_rank: number;
	readonly previous_overall_points: number;
	readonly description: string;
	is_commissioner: boolean;
}

export interface ILeaguesReducerState {
	leagues: ILeague[];
	is_leagues_data_fetched: boolean;
}

const initialState: ILeaguesReducerState = {
	leagues: [],
	is_leagues_data_fetched: false
};

export const leagues = createReducer({}, initialState)
	.on(actions.fetchMyLeaguesSuccess, (_state, payload) => ({
		leagues: payload,
		is_leagues_data_fetched: true
	}))
	.on(actions.fetchMyLeaguesFailed, () => ({
		...initialState
	}));
